import React from 'react'
import ReceiptRules from 'src/app/Receipt Rules/ReceiptRules'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { receiptRulesRouteProps } from 'src/navigation/routeProps'

const ReceiptRulesAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsReceiptRules,
  routeProps: receiptRulesRouteProps,
  component: <ReceiptRules />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default ReceiptRulesAppRoute
